import { dew as _lazyDew } from "./lazy";
import { dew as _lazyObjectDew } from "./lazyObject";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.lazyObject = exports.lazy = void 0;
  var lazy_1 = _lazyDew();
  Object.defineProperty(exports, "lazy", {
    enumerable: true,
    get: function () {
      return lazy_1.lazy;
    }
  });
  var lazyObject_1 = _lazyObjectDew();
  Object.defineProperty(exports, "lazyObject", {
    enumerable: true,
    get: function () {
      return lazyObject_1.lazyObject;
    }
  });
  return exports;
}